// extracted by mini-css-extract-plugin
export default {"title":"PeakFlow_title__A7i8r"};